<template>
  <v-data-table
    dense
    disable-pagination
    hide-default-footer
    :headers="headers"
    :items="assessments"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
  >
    <template v-slot:[`item.session.completionDate`]="{ value }">
      {{ value | formatDate }}
    </template>
    <template v-slot:[`item.passed`]="{ value }">
      {{ value | yesNo('No assessment') }}
    </template>
    <template v-slot:[`item.assessment`]="{ value }">
      {{ value | percentage(0, 'No assessment') }}
    </template>
    <template v-slot:[`item.certificate`]="{ item }">
      <v-btn
        :loading="downloadingCertificate === item._id"
        :disabled="!item.passed"
        small
        icon
        @click="downloadCertificate(item)"
      >
        <v-icon>
          picture_as_pdf
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import log from 'loglevel'
import gql from 'graphql-tag'
import { generateTrainingCertificatePdf } from '../integrations/mymsa-pdf'

export default {
  name: 'TraineeAssessmentTable',

  props: {
    personId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    assessments: [],
    headers: [
      { text: 'Date', value: 'session.completionDate' },
      { text: 'Venue', value: 'session.venue' },
      { text: 'Unit', value: 'unitCode' },
      { text: 'Passed', value: 'passed' },
      { text: 'Assessment', value: 'assessment' },
      { text: 'Certificate', value: 'certificate' }
    ],
    sortBy: 'session.completionDate',
    sortDesc: true,
    downloadingCertificate: null
  }),

  apollo: {
    assessments: {
      query: gql`query TraineeAssessments ($filter: FilterFindManyTrainingAssessmentInput) {
        assessments: trainingAssessmentMany(limit: 0, filter: $filter) {
          _id
          unitCode
          passed
          assessment
          sessionId
          session {
            _id
            scheduledDate
            completionDate
            module {
              _id
              units {
                _id
                code
                description
              }
            }
          }
          person {
            _id
            name
          }
        }
      }`,
      variables () {
        return {
          filter: {
            personId: this.personId
          }
        }
      },
      error (e) {
        this.onError(e)
      }
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    },

    async downloadCertificate (item) {
      this.downloadingCertificate = item._id

      // Get all assessments for the session (which is for one module, 1 to many units)
      const matchedAssessments = this.assessments.filter(o => o.passed && o.sessionId === item.sessionId)

      let result
      try {
        result = await generateTrainingCertificatePdf(matchedAssessments)
      } catch (e) {
        log.error(e)
        this.onError(new Error('Failed to generate PDF. Please try again.'))
        return
      } finally {
        this.downloadingCertificate = null
      }
      window.open(result.presignedUrl, '_blank').focus()
      this.$emit('info', 'Certificate opened in new tab.')
    }
  }
}
</script>
